"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Domain Roles Mask API
 * Returns an object indicating which rights have been forced due to a domain role mask. This does not indicate which mask would have triggered the override, only that the right is being overridden. The rights returned by admin/rights is an accurate list of which rights the user currently has. i.e. the absence of a right in admin/roles and presence here indicates that a mask has removed the right. Likewise, a right present in admin/roles and absent here means no mask has modified it.  # Changelog  ## 1.0.3  More changes to the schemas structure  ## 1.0.2  Changes to the schemas structure  ## 1.0.1  Hopefully fix serialization issue  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleToJSON = exports.RoleFromJSONTyped = exports.RoleFromJSON = void 0;
function RoleFromJSON(json) {
    return RoleFromJSONTyped(json, false);
}
exports.RoleFromJSON = RoleFromJSON;
function RoleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
exports.RoleFromJSONTyped = RoleFromJSONTyped;
function RoleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}
exports.RoleToJSON = RoleToJSON;
